import React, { useState } from "react";
import "react-bootstrap-table-next/dist/react-bootstrap-table2.min.css";
import "react-bootstrap-table2-toolkit/dist/react-bootstrap-table2-toolkit.min.css";

import BootstrapTable from "react-bootstrap-table-next";
import paginationFactory from "react-bootstrap-table2-paginator";
import ToolkitProvider, {
  Search,
} from "react-bootstrap-table2-toolkit/dist/react-bootstrap-table2-toolkit";
// import { useNavigate } from "react-router-dom";
// import { useDispatch } from "react-redux";
// import { deleteAndRestoreProduct } from "../reduxSaga/actions";
import { Alert, Snackbar } from "@mui/material";
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";
// import RestoreFromTrashRoundedIcon from "@material-ui/icons/RestoreFromTrashRounded";

const fmtPrice = (cell) => cell != null ? parseFloat(Number(cell).toFixed(3)) : "";

const DataTableProductsPurchase = ({ listProduits }) => {
  // const navigate = useNavigate();
  // const dispatch = useDispatch();
  console.log("listProduits", listProduits);
  const [products, setProducts] = useState(listProduits);
  // const [openErrorAlert, setOpenErrorAlert] = useState(false);
  const [infoAlertText, setInfoAlertText] = useState();
  const [openInfoAlert, setOpenInfoAlert] = useState(false);

  const { SearchBar } = Search;
  const getCellValue = (row, column) => {
    if (column.dataField === "manufacturingBatch") {
      return row.manufacturingBatch && row.manufacturingBatch.serialNumber
        ? row.manufacturingBatch.serialNumber
        : "";
    }
    const value = column.dataField
      .split(".")
      .reduce((acc, key) => (acc == null ? acc : acc[key]), row);
    if (value === null || value === undefined) return "";
    return typeof value === "number" ? parseFloat(Number(value).toFixed(3)) : value;
  };

  const MyExportExcel = ({ data }) => {
    const handleClick = () => {
      const exportColumns = columns.filter(
        (c) => c.dataField && !c.isDummyField && typeof c.text === "string"
      );
      const rows = [
        exportColumns.map((c) => c.text),
        ...(data || []).map((row) => exportColumns.map((c) => getCellValue(row, c))),
      ];
      const worksheet = XLSX.utils.aoa_to_sheet(rows);
      worksheet["!cols"] = exportColumns.map((c) => ({
        wch: Math.max(14, String(c.text).length + 4),
      }));
      const workbook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(workbook, worksheet, "Produits");
      const buffer = XLSX.write(workbook, { bookType: "xlsx", type: "array" });
      saveAs(
        new Blob([buffer], { type: "application/octet-stream" }),
        "produits.xlsx"
      );
    };
    return (
      <div>
        <button className="btn btn-dark" onClick={handleClick}>
          <i className="fas fa-file-excel mr-1"></i> Télécharger Excel
        </button>
      </div>
    );
  };

  function lotFormatter(cell, row) {
    console.log("cell", cell);
    if (cell === undefined || cell === null) {
      return <span>-----------</span>;
    } else {
      return <span>{cell.serialNumber}</span>;
    }
  }

  const columns = [
    {
      dataField: "product.name",
      text: "Libellé",
      headerAlign: "center",
      // headerStyle: () => {
      //   return { width: "20%" };
      // },
    },
    {
      dataField: "product.productCode",
      text: "Code",
      align: "center",
      headerAlign: "center",
      headerStyle: () => {
        return { width: "10%" };
      },
    },
    {
      dataField: "manufacturingBatch",
      text: "Lot",
      formatter: lotFormatter,
      align: "center",
      headerAlign: "center",
      headerStyle: () => {
        return { width: "10%" };
      },
    },
    {
      dataField: "tva",
      text: "TVA",
      align: "center",
      headerAlign: "center",
      headerStyle: () => {
        return { width: "8%" };
      },
    },
    {
      dataField: "quantity",
      text: "Qte",
      align: "center",
      headerAlign: "center",
      headerStyle: () => {
        return { width: "8%" };
      },
    },

    {
      dataField: "initialPriceHtc",
      text: "Prix.U",
      align: "center",
      headerAlign: "center",
      formatter: fmtPrice,
      headerStyle: () => {
        return { width: "12%" };
      },
    },
    {
      dataField: "promotionPercentage",
      text: "Remise",
      align: "center",
      headerAlign: "center",
      headerStyle: () => {
        return { width: "10%" };
      },
    },
    {
      dataField: "buyinfPrice",
      text: "Prix.A.U",
      align: "center",
      headerAlign: "center",
      formatter: fmtPrice,
      headerStyle: () => {
        return { width: "12%" };
      },
    },
    {
      dataField: "priceTt",
      text: "Prix.U.TT",
      align: "center",
      headerAlign: "center",
      formatter: fmtPrice,
      headerStyle: () => {
        return { width: "12%" };
      },
    },
  ];

  const rates = (row) => {
    if (row.ratePPs.length !== 0) {
      console.log("rates", row.ratePPs);
      return (
        <div class="col-md-12">
          <div class="card card-dark collapsed-card">
            <div class="card-header">
              <h3 class="card-title">
                Prix d'achat + coût de revient: {fmtPrice(row.finalPriceHtc)} /{" "}
                {fmtPrice(row.finalPriceTt)}
              </h3>
              <div class="card-tools">
                <button
                  type="button"
                  class="btn btn-tool"
                  data-card-widget="collapse"
                >
                  <i class="fas fa-plus"></i>
                </button>
              </div>
            </div>

            <div class="card-body">{listRates(row.ratePPs)}</div>
          </div>
        </div>
      );
    }
  };
  const listRates = (list) => {
    return (
      <table
        class="table table-striped table-bordered table-sm"
        cellspacing="0"
        width="100%"
      >
        <thead>
          <tr className="text-center">
            <th style={{ width: "40%" }}>Libellé</th>
            <th style={{ width: "30%" }}>Valeur</th>
            <th style={{ width: "30%" }}>Ref Facture</th>
          </tr>
        </thead>
        <tbody>
          {list &&
            list.map((element, i) => (
              <tr className="text-center" key={i}>
                <td>{element.name}</td>
                <td>{element.value} </td>
                <td>{formatRefBill(element)}</td>
              </tr>
            ))}
        </tbody>
      </table>
    );
  };
  const formatRefBill = (rate) => {
    // console.log("row", row);
    if (
      rate.refBill !== null &&
      rate.refBill !== "none" &&
      rate.refBill !== ""
    ) {
      return <span>{rate.refBill}</span>;
    } else {
      return <span>-----------</span>;
    }
  };
  const importProduct = (row) => {
    if (row.isImport === 1) {
      return (
        <div className="row">
          {" "}
          <p> Local</p>
          {rates(row)}
        </div>
      );
    } else {
      return (
        <div className="row">
          <div class="col-md-12">
            <p>Importé</p>
          </div>
          <div class="col-md-12">
            <p>{`Prix Unitaire sans remise: ${fmtPrice(row.currencyPrice)}`}</p>
          </div>
          <div class="col-md-12">
            <p>{`Prix Unitaire avec remise: ${fmtPrice(
              row.currencyPrice -
              (row.currencyPrice * row.promotionPercentage) / 100
            )}`}</p>
          </div>
          <div class="col-md-12">
            <p>{`Devise: ${row.currency}`}</p>
          </div>
          <div class="col-md-12">
            <p>{`Taux de change: ${row.exchangeRate}`}</p>
          </div>
          {rates(row)}
        </div>
      );
    }
  };
  const expandRow = {
    renderer: (row) => importProduct(row),
    showExpandColumn: true,
    expandHeaderColumnRenderer: ({ isAnyExpands }) => {
      if (isAnyExpands) {
        return <b style={{ cursor: "pointer" }}>-</b>;
      }
      return <b style={{ cursor: "pointer" }}>+</b>;
    },
    expandColumnRenderer: ({ expanded }) => {
      if (expanded) {
        return <b style={{ cursor: "pointer" }}>-</b>;
      }
      return <b style={{ cursor: "pointer" }}>+</b>;
    },
  };

  const handleInfoClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setOpenInfoAlert(false);
  };

  // function handleTableChange({ products }) {
  //   return products;
  // }
  const pageButtonRenderer = ({
    page,
    active,
    disable,
    title,
    onPageChange,
  }) => {
    const handleClick = (e) => {
      e.preventDefault();
      onPageChange(page);
    };
    const activeStyle = {};
    if (active) {
      activeStyle.backgroundColor = "black";
      activeStyle.color = "white";
    } else {
      activeStyle.backgroundColor = "white";
      activeStyle.color = "black";
    }
    if (typeof page === "string") {
      activeStyle.backgroundColor = "white";
      activeStyle.color = "black";
    }
    return (
      <li className="page-item">
        <button
          className="btn btn-dark"
          onClick={handleClick}
          style={activeStyle}
        >
          {page}
        </button>
      </li>
    );
  };
  const options = {
    pageButtonRenderer,
  };

  return (
    <div
      className="card"
      style={{ borderRadius: 8, boxShadow: "0 1px 6px rgba(0,0,0,.08)" }}
    >
      <div className="card-header">
        <h3 className="card-title">
          <i className="fas fa-boxes mr-2"></i>Produits
          <span className="badge badge-dark ml-2">
            {products ? products.length : 0}
          </span>
        </h3>
      </div>
      <div className="card-body">
        <ToolkitProvider
          keyField="id"
          data={products}
          columns={columns}
          //   onTableChange={handleTableChange}
          exportCSV
          search
        >
          {(props) => (
            <div>
              <div className="row ml-0 mb-3 align-items-center">
                <div>
                  <SearchBar
                    {...props.searchProps}
                    className="custome-search-field"
                    style={{ color: "black" }}
                    placeholder="Chercher"
                  ></SearchBar>
                </div>
                <div className="ml-auto mr-0">
                  <MyExportExcel data={props.baseProps.data}></MyExportExcel>
                </div>
              </div>
              <div className="row table-responsive mx-0">
                <BootstrapTable
                  {...props.baseProps}
                  pagination={paginationFactory(options)}
                  headerClasses="thead-light"
                  wrapperClasses="w-100"
                  striped
                  hover
                  condensed
                  expandRow={expandRow}
                />
              </div>
            </div>
          )}
        </ToolkitProvider>
      </div>

      {openInfoAlert && (
        <Snackbar
          open={openInfoAlert}
          autoHideDuration={2000}
          onClose={handleInfoClose}
          anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
        >
          <Alert variant="filled" onClose={handleInfoClose} severity="info">
            {infoAlertText}
          </Alert>
        </Snackbar>
      )}
    </div>
  );
};
export default DataTableProductsPurchase;
